import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './instant-website-data.reducer';
import { InstantWebsiteDataService } from './instant-website-data.service';
import { InstantWebsiteDataEffects } from './instant-website-data.effects';
import { InstantWebsiteDataStore } from './instant-website-data.store';
import { InstantWebsiteDataDispatcher } from './instant-website-data.dispatcher';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([InstantWebsiteDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class InstantWebsiteDataModule {
  static forRoot(): ModuleWithProviders<InstantWebsiteDataModule> {
    return {
      ngModule: InstantWebsiteDataModule,
      providers: [InstantWebsiteDataService, InstantWebsiteDataStore, InstantWebsiteDataDispatcher],
    };
  }
}
